module.exports = __webpack_public_path__ + "img/sp4.8ff1d8b7.png";